import React from 'react';
import LoadingIcon from '../Icons/Loading';

export interface ButtonProps {
  text?: string | JSX.Element;
  type?: 'submit' | 'reset' | 'button' | undefined;
  onClick?: () => void;
  loading?: boolean;
  disabled?: boolean;
  buttonStyle?:
    | 'white'
    | 'black'
    | 'red'
    | 'green'
    | 'primary'
    | 'secondary'
    | 'gradiented'
    | 'transparent-white'
    | 'transparent-black'
    | 'transparent-primary'
    | 'transparent-secondary';
  isLink?: boolean;
  href?: string;
  loadingColor?: string;
}

const Button = React.forwardRef(
  (
    {
      text = 'Save',
      type = 'button',
      onClick = () => {},
      loading = false,
      disabled = false,
      buttonStyle = 'primary',
      isLink = false,
      href,
      loadingColor,
    }: ButtonProps,
    ref
  ) => {
    const darkThemes = ['black', 'red', 'green', 'primary'];

    const getClasses = () => {
      let theme = `bg-primary hover:bg-primary-dark`;

      if (buttonStyle === 'secondary')
        theme = `bg-secondary hover:bg-secondary-dark`;

      if (buttonStyle === 'white') theme = 'bg-white hover:bg-gray-50';
      if (buttonStyle === 'black') theme = 'bg-black hover:bg-gray-800';

      if (buttonStyle === 'red') theme = 'bg-red-600 hover:bg-red-700';
      if (buttonStyle === 'green') theme = 'bg-green-600 hover:bg-green-700';

      let textTheme = darkThemes.includes(buttonStyle)
        ? 'text-white'
        : 'text-black';

      if (buttonStyle.includes('transparent-')) {
        textTheme = '';
        const transparentTheme = buttonStyle.split('-')[1];

        if (transparentTheme === 'primary')
          theme = `bg-transparent border border-primary hover:border-primary-dark text-primary hover:text-primary-dark`;

        if (transparentTheme === 'secondary')
          theme = `bg-transparent border border-secondary hover:border-secondary-dark text-secondary hover:text-secondary-dark`;

        if (transparentTheme === 'white')
          theme =
            'bg-transparent border border-white hover:border-gray-50 text-white';
        if (transparentTheme === 'black')
          theme =
            'bg-transparent border border-black hover:border-gray-800 text-black';
      }

      if (buttonStyle === 'gradiented')
        theme =
          'bg-gradient-to-b from-primary bg-secondary hover:from-primary-dark hover:bg-secondary-dark';

      let xx = `flex justify-center items-center w-full h-12 text-base leading-6 font-regular shadow-md focus:outline-none transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-50 cursor-pointer disabled:cursor-not-allowed ${theme} ${textTheme}`;

      return xx;
    };

    if (isLink)
      return (
        <a
          // @ts-ignore
          ref={ref}
          href={href}
          className={`rounded-full ${getClasses()}`}
          style={{ minWidth: '120px' }}
        >
          {loading ? (
            <LoadingIcon
              size={20}
              color={
                loadingColor ?? darkThemes.includes(buttonStyle)
                  ? 'white'
                  : 'black'
              }
            />
          ) : (
            text
          )}
        </a>
      );

    return (
      <button
        type={type}
        onClick={onClick}
        disabled={disabled}
        className={`rounded-full ${getClasses()}`}
        style={{ minWidth: '120px' }}
      >
        {loading ? (
          <LoadingIcon
            size={20}
            color={
              loadingColor ?? darkThemes.includes(buttonStyle)
                ? 'white'
                : 'black'
            }
          />
        ) : (
          text
        )}
      </button>
    );
  }
);

export default Button;
